export default "__VITE_ASSET__BcbzB2mP__"